export const DELIVERY_SLOT_OPTIONS = [
  { id: 1, slot: 1, label: '1:00 PM - 4:00 PM', compactLabel: '1-4 pm', start: '13:00', end: '16:00' },
  { id: 2, slot: 2, label: '2:00 PM - 5:00 PM', compactLabel: '2-5 pm', start: '14:00', end: '17:00' },
  { id: 3, slot: 3, label: '3:00 PM - 6:00 PM', compactLabel: '3-6 pm', start: '15:00', end: '18:00' },
  { id: 4, slot: 4, label: '4:00 PM - 7:00 PM', compactLabel: '4-7 pm', start: '16:00', end: '19:00' },
  { id: 5, slot: 5, label: '5:00 PM - 8:00 PM', compactLabel: '5-8 pm', start: '17:00', end: '20:00' },
  { id: 6, slot: 6, label: '6:00 PM - 9:00 PM', compactLabel: '6-9 pm', start: '18:00', end: '21:00' },
];

export const DELIVERY_SLOT_GROUP_DEFINITIONS = [
  {
    id: 'early-afternoon',
    label: 'Tarde temprana',
    afternoonOnly: false,
    slotIds: [1, 2, 3],
  },
  {
    id: 'late-afternoon',
    label: 'Tarde',
    afternoonOnly: true,
    slotIds: [4, 5],
  },
  {
    id: 'evening',
    label: 'Noche',
    afternoonOnly: true,
    slotIds: [6],
  },
];

export function findDeliverySlot(slot) {
  const numericSlot = Number(slot);
  return DELIVERY_SLOT_OPTIONS.find((item) => item.slot === numericSlot || item.id === numericSlot) || null;
}

export function getDeliverySlotLabel(slot, { compact = false } = {}) {
  const item = findDeliverySlot(slot);
  if (!item) return null;
  return compact ? item.compactLabel : item.label;
}

export function deliverySlotsByIds(slotIds = []) {
  const wanted = new Set(slotIds.map(Number));
  return DELIVERY_SLOT_OPTIONS.filter((item) => wanted.has(item.id));
}

export function availableDeliverySlots({ afternoonOnly = false } = {}) {
  return DELIVERY_SLOT_OPTIONS.filter((item) => !afternoonOnly || item.id >= 4);
}
